import React, { FC } from 'react'

import styles from '../Story.module.scss'
import { cn } from '../../../shared/utils'
import { useStoryContext } from '../StoryContext'
import { getArtistImagePath } from '../../../shared/utils/getArtistImagePath'
import { Icon } from '@wmgtech/legato'
import { Link } from 'react-router-dom'
import { ZoneBadge } from './ZoneBadge'
import { useNewStoryNotification } from '../../../modules/Feed/serviceHooks'
import { NewBadge } from './NewBadge'
import { useURLBuilder } from '../../../shared/hooks'
import { useCurrentUser } from '../../../modules/User/useCurrentUser'
import { ENABLED_FEATURES } from '../../../shared/utils/featureFlags'

type TStoryHeaderProps = {
  actions?: React.ReactNode
  children?: React.ReactNode
}

export const StoryHeader: FC<TStoryHeaderProps> = (props) => {
  const { getProjectPageUrl } = useURLBuilder()

  const story = useStoryContext()
  const { user } = useCurrentUser()
  const isGlobal = story.global_status === 'PUBLISHED'
  const isInGlobalProject = story.campaign.global_status === 'PUBLISHED'
  const { isExistInNotifications, storyRef } = useNewStoryNotification(story)
  const hasTag = isGlobal && story.shared_from?.label_id ?
    user?.label_id !== story.shared_from?.label_id :
    user?.label_id !== story.campaign?.label_id

  return (
    <div ref={storyRef} className={cn(styles.header, styles.section)}>
      <Link to={getProjectPageUrl(story.campaign_id, isInGlobalProject)} className={styles.projectMainInfo}>
        <img
          src={getArtistImagePath(story.artist.spotify_id, story.artist.facebook_id, 'xs')}
          className={styles.artistImage}
          alt={story.artist.name ?? ''}
        />
        <div>
          <div className={styles.titleRow}>
            <h3 className={cn('lgt-title', styles.title)}>{story.artist.name}</h3>
            {ENABLED_FEATURES.GLOBALHUB && (
              isGlobal && <Icon name="badge-check" prefix="fas" className={styles.globalBadge} />
            )}
            <NewBadge isVisible={isExistInNotifications} />
            {hasTag && <ZoneBadge />}
          </div>
          <div className={cn(styles.subtitleRow, 'text-lg')}>{story.campaign.name}</div>
        </div>
      </Link>
      {story.pinned && <Icon name="thumbtack" prefix="fas" className={styles.pinnedBadge} />}
      <div className={styles.actions}>{props.actions}</div>
      {props.children}
    </div>
  )
}
